
import qs from 'qs'
import Url from 'url-parse'
// import stores from '../state'
// import { ContentProps,FileProps, Owner } from '../views/Home/components/Question'
import html2canvas from 'html2canvas'
import sleep from 'sleep-promise'
import Watermark from '../components/Watermark/Watermark'
import moment from 'moment'
import { useStore } from 'react-redux'

import _ from 'lodash'
import Parse from 'parse'
import axios from 'axios'
import * as cheerioModule from 'cheerio'
// import cheerio from 'cheerio'


export type EmojiProps = {
    source:  string;
    type: 'image'| 'text'
    order: number,
    title: string;  
}


export const isDarkMode = ()=>{
  return false
}

export const textColorStyle = ()=>{
  return {}
}

export const backgroundStyle = ()=>{
  // return {backgroundColor:'white'}
  return {}
}

export const isAuthorized = ()=>{
  return true
}
export const isFollowed = (id:any)=>{
  return true
}

export const isCollected = (id:string)=>{
  return true
}

export const getThemeData = (a:string,b:string)=>{  
  return ''
}  

export function identifyEmoji(text:string){
    var r=/\[(.*?)\]/g, a=[], m;
    while (m = r.exec(text)) {
      a.push(m);
    }
    return a;
}

export function identifyTextEmoji(text:string){
    var r=/(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f])|(\ud83d[\ude80-\udeff])/g, a=[], m;
    while (m = r.exec(text)) {
      a.push(m);
    }
    return a;
}

 

export async function getPublicIP(){
  return await getPublicIP0()
}

async function getPublicIP0(){
  const {data} = await axios('https://2024.ip138.com/')
  const $ = cheerioModule.load(data)
  const ipstr = $('title').eq(0).text()
  console.log('ipstr',ipstr)
  return ipstr.replace('您的IP地址是：','')
}

// async function getPublicIP1(){
//   try{
//     const {data} = await axios('https://www.ipshudi.com/')
//     const $ = cheerio.load(data)
//     const ip  = $('.input-text').eq(0).attr('value')
//     return ip
//   }catch(e){
//     console.error('getPublicIP1',e)
//   }
// }
 
function _openParedLink(newWindow:Window,topicId:string){
  if(newWindow){
    newWindow.location = topicId
  }else{
    window.open(topicId,'_blank');
  }
}
export function openParsedLink(newWindow:Window,topicId:string){
  if(topicId.indexOf('http')>=0 || topicId.startsWith('#') ){
    _openParedLink(newWindow,topicId)
  }else{
    // if(topicId.indexOf('#/article')==0){
    //   _openParedLink(newWindow,topicId)
    // }else{
      _openParedLink(newWindow,'#/article/'+topicId)
    // }
  }
}

export function parseTopicId(url:string=''){
    const u = new Url(url)
    let topic_id = ''
    if(url.indexOf('articles.zsxq.com/')>=0){
      return u.pathname.replace('/id_','').replace('.html','')
    }
    if(u.query){ 
        const query = <string> <unknown> u.query
        topic_id = <string> qs.parse(query.replace('?','')).topic_id
    }else{ 
        topic_id = u.pathname.substr(u.pathname.lastIndexOf('/')+1)
    } 
    
    // 判断是否为14位数字
    return /^\d{10,}$/g.test(topic_id) ? topic_id:''
}
 

export async function downloadPageCanvas(id?:string){
    let dom 
    // if(id){
        dom = document.getElementsByClassName('content-container')[0];
        
    if(!dom){
        dom = document.getElementsByTagName('body')[0];
    }
    // // noscript 要先删除noscript标签
    try{
        document.getElementsByTagName('noscript')[0].innerText=''
    }catch(e){

    }
    // @ts-ignore
      const canvas = await html2canvas(dom,{useCORS:true});
      const data = canvas.toDataURL('image/jpeg',1);
      // canvas.baseURI
      console.log('canvas',canvas.width,canvas.height,) 
      
      const wm = new Watermark(canvas);
    
    wm.setOptions({text:'',watermarkWidth:400,watermarkHeight:300,fontSize:50,fillStyle:'rgba(200, 200, 200, 0.4)',rotate:20});
      wm.draw(data);
      await sleep(100)
      const img = canvas.toDataURL("image/jpeg",0.2);
      console.log('img',img.length,img.substr(0,100))
       var alink = document.createElement("a");
      alink.href = img;
      alink.download =  document.title + '.jpg';
      alink.click();
}
 
export async function getBlobImage(url:string):Promise<string>{
    // return new Promise((resolve,reject)=>{
    //     var xhr = new XMLHttpRequest();
    //     xhr.open('get', url, true);
    //     xhr.responseType = 'blob';
    //     xhr.onload = function () {
    //         if (this.status == 200) {
    //             resolve(URL.createObjectURL(this.response))
    //         }else{
    //             reject()
    //         }
    //     };
    //     xhr.send();
    // })
    return url
}

export function isAvatarExpired(url:string){
  if(!url){
    return false
  }
    // return true
    // https://images.zsxq.com/FjDsI7vSd5Y5wyhs8I5cIE8Ny4LU?e=1635695999&token=kIxbL07-8jAj8w1n4s9zv64FuZZNEATmlU_Vm6zD:N22dZhqx6vkuaEXzT0SWT6wZNN8=
    const {e,Expires} = qs.parse(url.substr(url.indexOf('?')+1))
    const expire = e || Expires
    const d = new Date()
    // @ts-ignore
    d.setTime(expire*1000)
    const diff = moment().diff(moment(d),'seconds') 
    console.log('isAvatarExpired diff seconds',diff)
    return diff > 0
}
   
export function getContentHolder(article:Parse.Object|any): Question | TaskProps| TalkProps{
  if(!article){
    return
  } 
  let content:ContentProps
  if(article.get){
    content = article.get('content')
  }else{
    content = article
  }
  switch(content.type){
    case 'q&a':
        return content.question;
    case 'solution':
        return content.solution;
    case 'talk':
        return content.talk;
    case 'task':
        return content.task;
  }
}
export function getContentTextOfArticle(article:Parse.Object | any):string{
  return getContentHolder(article).text
}

export function getFiles(content:ContentProps): FileProps[]{
    // const content:ContentProps = article.get('content')
    switch(content.type){
        case 'q&a':
            return content.question.files;
        case 'solution':
            return content.solution.files;
        case 'talk':
            return content.talk.files;
        case 'task':
            return content.task.files;
    }
}

export function getComment(article:Parse.Object){
    const content:ContentProps = article.get('content')
    return content.show_comments
}


export type ThemeMode = 'light'|'dark';
  


export function getNewTypeId(type:number){
  switch(type){
    case 30:
      return 10005
    case 1:
      return 10001
    case 2:
      return 10002
    case 3:
      return 10003
    case 5:
      return 10201
    case 6:
      return 10202
    case 7:
      return 10203
    case 8:
      return 10204
    case 9:
      return 10101
    case 10:
      return 10102
    case 11:
      return 10103
    case 12:
      return 10104
    case 13:
      return 10301
    case 14:
      return 10302
    case 15:
      return 10303
    case 16:
      return 10304
  }
   // wingo 30 10005
  // wingo 1 10001
  // wingo 2 10002
  // wingo 3 10003
  // 5d 5 10201
  // 5d 6 10202
  // 5d 7 10203
  // 5d 8 10204
  // k3 9 10101
  // k3 10 10102
  // k3 11 10103
  // k3 12 10104
  // trx 13 10301
}
// type为1-16之间的数字
export function getCurrentIssueNumber(type:number,date?:Date){
  if(!date){
    date = new Date()
  }
  // const five_thirty_moment1 = moment(date).utcOffset(5.5)
  // let five_thirty_moment2 = moment(date).utcOffset(5.5) 
  const five_thirty_moment1 = moment(date).utcOffset(0)
  let five_thirty_moment2 = moment(date).utcOffset(0) 
  const _type = type%4;
 
  
  

  const zeroMoment = five_thirty_moment1.hour(0).minute(0).second(0)
  const currentMinutes = five_thirty_moment2.diff(zeroMoment,'minute') 
  const currentSeconds = five_thirty_moment2.diff(zeroMoment,'seconds') 
  
  let issueNumber = 0

  if(type==30){
    issueNumber = parseInt(currentSeconds/30+'');
    if(issueNumber===0){
      issueNumber = 2880
      five_thirty_moment2 = five_thirty_moment2.subtract(1,'days')
    }
    
  }else{
    switch(_type){
      case 1:
        issueNumber = currentMinutes;
        if(issueNumber===0){
          issueNumber = 1440
          five_thirty_moment2 = five_thirty_moment2.subtract(1,'days')
        }
        break;
      case 2: 
        issueNumber =  Math.floor(currentMinutes /3);
        if(issueNumber===0){
          issueNumber = 480;
          five_thirty_moment2 = five_thirty_moment2.subtract(1,'day')
        }
        break;
      case 3:
        issueNumber =  Math.floor(currentMinutes /5);
        if(issueNumber===0){
          issueNumber = 288;
          five_thirty_moment2 = five_thirty_moment2.subtract(1,'day')
        }
        break;
      case 0:
        issueNumber =  Math.floor(currentMinutes / 10);
        if(issueNumber===0){
          issueNumber = 144;
          five_thirty_moment2 = five_thirty_moment2.subtract(1,'day')
        }
        break;
    }
  }
  return five_thirty_moment2.format('YYYYMMDD')+getNewTypeId(type)+(issueNumber+'').padStart(4,'0') 
}

export function getNextIssueNumber(type:number,date?:Date){
  if(!date){
    date = new Date()
  }
  const five_thirty_moment1 = moment(date).utcOffset(0)
  let five_thirty_moment2 = moment(date).utcOffset(0) 
  const _type = type%4;
  const zeroMoment = five_thirty_moment1.hour(0).minute(0).second(0)
  const currentMinutes = five_thirty_moment2.diff(zeroMoment,'minute') 
  const currentSeconds = five_thirty_moment2.diff(zeroMoment,'seconds')  
  let issueNumber = 0
  if(type==30){
    issueNumber = parseInt(currentSeconds/30+'')+1;
  }else{
    switch(_type){
      case 1:
        issueNumber = currentMinutes+1;
        break;
      case 2: 
        issueNumber =  Math.floor(currentMinutes /3)+1;
        break;
      case 3:
        issueNumber =  Math.floor(currentMinutes /5)+1;
        break;
      case 0:
        issueNumber =  Math.floor(currentMinutes / 10)+1;
        break;
    }
  }
  return five_thirty_moment2.format('YYYYMMDD')+getNewTypeId(type)+(issueNumber+'').padStart(4,'0') 
} 

export function secondToMinuteStr(time:number){
  const minutes = Math.floor(time / 60);
  const seconds = time - minutes * 60;  
  return (minutes+'').padStart(2,'0')+':'+(seconds+'').padStart(2,'0')
}
 


export type Owner = {
  name: string;
  user_id: number;
  avatar_url: string;
  update_time?: string;
  // 星球简介
  description: string;
  // 个人签名
  introduction: string;
  remark: string;
  unique_id?: string;
  location?: string;
}

type Answer = {
  owner: Owner;
  text: string;
  name: string;
  images: ImageProps[];
}
type Question = {
  owner: Owner;
  name: string;
  text: string;
  images: ImageProps[];
  files: FileProps[];
  questionee: Owner;
  expired: boolean;
  anonymous: boolean;
  fee: {
      amount: number;
  }
}

type Like = {
  owner: Owner;
}

type Reward  = Like & {
  // owner:Owner;
  amount: number;
}

export function getRefererPolicy(imgUrl:string=''){
  // return 'no-referrer-when-downgrade'
  // return 'origin'
  if(imgUrl.indexOf('.myqcloud.com')>=0){
    return 'origin'
  }
  return 'no-referrer'
}
export type CommentProps = {
  owner: Owner;
  repliee: Owner;
  text: string;
  comment_id: number;
  images: ImageProps[];
  create_time: string;
  replies_count: number;
  rewards_count: number;
  parent_comment_id: number;
  replied_comments: RepliedCommentProps[];
}
export type RepliedCommentProps = {
  parent_comment_id: number;
} & CommentProps

type URLProps = {
  url: string;
  width?: number;
  height?: number;
  size?: number;
}
export type ImageProps = {
  large: URLProps;
  original: URLProps;
  thumbnail: URLProps;
}

export type FileProps = {
  file_id:string;
  name:string;
  hash:string;
  size:number;
  download_count:number;
  create_time:string;
}
type TalkProps = {
  text: string;
  owner: Owner;
  video: VideoProps;
  images: ImageProps[];
  files: FileProps[];
}

type TaskProps = {
  task_id: number;
 
} & TalkProps

type VideoProps = {
 
  video_id: number;
  cover: URLProps;
  duration: number;
  size: number;
}

export type ContentProps = {
  annotation?: string;
  answer: Answer;
  talk: TalkProps;
  statistics:{
      submitted_count:number;
  }
  task: TaskProps;
  solution: TaskProps;
  text: string;
  images: ImageProps[];
  question: Question;
  likes_count: number;
  type: 'q&a'|'solution'|'task'|'talk';
  create_time: Date;
  latest_likes: Like[];
  rewards: Reward[];
  // 是否是精华
  digested: boolean;
  topic_id: string;
  readers_count: number;
  show_comments: CommentProps[];
  referenced_topic?: {topic: ContentProps};
}